import activityBonusConfig from "./zh-CN/activityBonusConfig";
import activityBonusHistory from "./zh-CN/activityBonusHistory";
import activityBonusRecord from "./zh-CN/activityBonusRecord";
import adjustAppConfig from "./zh-CN/adjustAppConfig";
import agentApproval from "./zh-CN/agentApproval";
import agentApprovalHistory from "./zh-CN/agentApprovalHistory";
import agentCashbackAdmin from "./zh-CN/agentCashbackAdmin";
import agentDetails from "./zh-CN/agentDetails";
import agentReport from "./zh-CN/agentReport";
import airdropConfig from "./zh-CN/airdropConfig";
import betActivity from "./zh-CN/betActivity";
import betOrder from "./zh-CN/betOrder";
import betReport from "./zh-CN/betReport";
import bonusApproval from "./zh-CN/bonusApproval";
import bonusRecord from "./zh-CN/bonusRecord";
import checkinRecord from "./zh-CN/checkinRecord";
import component from "./zh-CN/component";
import configAboutAdmin from "./zh-CN/configAboutAdmin";
import configLeftMenuAdmin from "./zh-CN/configLeftMenuAdmin";
import dailyRebateAdmin from "./zh-CN/dailyRebateAdmin";
import depositRecord from "./zh-CN/depositRecord";
import emailMarketing from "./zh-CN/emailMarketing";
import messageAdmin from "./zh-CN/messageAdmin";
import freeSpinConfig from "./zh-CN/freeSpinConfig";
import freeSpinRecord from "./zh-CN/freeSpinRecord";
import gameActions from "./zh-CN/gameActions";
import gamesManage from "./zh-CN/gamesManage";
import gemExchangeMallAdmin from "./zh-CN/gemExchangeMallAdmin";
import gemExchangeTagsAdmin from "./zh-CN/gemExchangeTagsAdmin";
import gemGoodsAdmin from "./zh-CN/gemGoodsAdmin";
import gemGoodsTypeAdmin from "./zh-CN/gemGoodsTypeAdmin";
import globalHeader from "./zh-CN/globalHeader";
import inviteBoxAdmin from "./zh-CN/inviteBoxAdmin";
import kFactor from "./zh-CN/kFactor";
import loginHistory from "./zh-CN/loginHistory";
import ltv from "./zh-CN/ltv";
import luckWheelDailyStatisticsReport from "./zh-CN/luckWheelDailyStatisticsReport";
import luckydrawConfig from "./zh-CN/luckydrawConfig";
import luckywheelRecord from "./zh-CN/luckywheelRecord";
import memberDeposits from "./zh-CN/memberDeposits";
import menu from "./zh-CN/menu";
import operationRecord from "./zh-CN/operationRecord";
import orderList from "./zh-CN/orderList";
import pages from "./zh-CN/pages";
import paymentPlatformAdmin from "./zh-CN/paymentPlatformAdmin";
import pixelsManagement from "./zh-CN/pixelsManagement";
import pwa from "./zh-CN/pwa";
import pwaDeviceList from "./zh-CN/pwaDeviceList";
import pwaNotificationList from "./zh-CN/pwaNotificationList";
import pwaNotificationTasks from "./zh-CN/pwaNotificationTasks";
import rolesAdmin from "./zh-CN/rolesAdmin";
import realTimeRebateAdmin from "./zh-CN/realTimeRebateAdmin";
import redemptionCodeConfig from "./zh-CN/redemptionCodeConfig";
import redemptionCodeRecord from "./zh-CN/redemptionCodeRecord";
import redPacketRain from "./zh-CN/redPacketRain";
import reliefFundActivity from "./zh-CN/reliefFundActivity";
import retentionRate from "./zh-CN/retentionRate";
import settingDrawer from "./zh-CN/settingDrawer";
import settings from "./zh-CN/settings";
import tagsAdmin from "./zh-CN/tagsAdmin";
import taskAdmin from "./zh-CN/taskAdmin";
import topupList from "./zh-CN/topupList";
import userDepositBonusAdmin from "./zh-CN/userDepositBonusAdmin";
import userList from "./zh-CN/userList";
import userPromotionsAdmin from "./zh-CN/userPromotionsAdmin";
import userReport from "./zh-CN/userReport";
import userRisk from "./zh-CN/userRisk";
import userVipAdmin from "./zh-CN/userVipAdmin";
import walletChangeList from "./zh-CN/walletChangeList";
import walletRecord from "./zh-CN/walletRecord";
import withdrawApproval from "./zh-CN/withdrawApproval";
import withdrawHistory from "./zh-CN/withdrawHistory";
import redPacketRecord from "./zh-CN/redPacketRecord";
import userDetails from "./zh-CN/userDetails";

export default {
  "navBar.lang": "语言",
  "layout.user.link.help": "帮助",
  "layout.user.link.privacy": "隐私",
  "layout.user.link.terms": "条款",
  "app.preview.down.block": "下载此页面到本地项目",
  "app.welcome.link.fetch-blocks": "获取全部区块",
  "app.welcome.link.block-list": "基于 block 开发，快速构建标准页面",
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...orderList,
  ...topupList,
  ...betOrder,
  ...gamesManage,
  ...gameActions,
  ...withdrawApproval,
  ...betReport,
  ...walletChangeList,
  ...depositRecord,
  ...ltv,
  ...kFactor,
  ...retentionRate,
  ...bonusRecord,
  ...userList,
  ...userRisk,
  ...withdrawHistory,
  ...memberDeposits,
  ...redemptionCodeRecord,
  ...redemptionCodeConfig,
  ...checkinRecord,
  ...freeSpinRecord,
  ...activityBonusConfig,
  ...freeSpinConfig,
  ...airdropConfig,
  ...pwaDeviceList,
  ...pwaNotificationList,
  ...pwaNotificationTasks,
  ...luckywheelRecord,
  ...walletRecord,
  ...userReport,
  ...tagsAdmin,
  ...activityBonusRecord,
  ...luckWheelDailyStatisticsReport,
  ...luckydrawConfig,
  ...loginHistory,
  ...operationRecord,
  ...agentApproval,
  ...agentApprovalHistory,
  ...adjustAppConfig,
  ...agentDetails,
  ...agentReport,
  ...userVipAdmin,
  ...dailyRebateAdmin,
  ...userDepositBonusAdmin,
  ...userPromotionsAdmin,
  ...gemGoodsTypeAdmin,
  ...gemGoodsAdmin,
  ...gemExchangeMallAdmin,
  ...gemExchangeTagsAdmin,
  ...agentCashbackAdmin,
  ...inviteBoxAdmin,
  ...configAboutAdmin,
  ...configLeftMenuAdmin,
  ...taskAdmin,
  ...pixelsManagement,
  ...rolesAdmin,
  ...paymentPlatformAdmin,
  ...emailMarketing,
  ...messageAdmin,
  ...bonusApproval,
  ...activityBonusHistory,
  ...redPacketRain,
  ...betActivity,
  ...reliefFundActivity,
  ...realTimeRebateAdmin,
  ...redPacketRecord,
  ...userDetails,
};
